export default [
  {
    header: "กองกฎหมาย",
    menu: "Law",
  },
  {
    title: "ธุรการกอง",
    route: "LawDeptlist",
    icon: "FileTextIcon",
    menu: "LawDeptlist",
  },
  {
    title: "จัดการผู้รับผิดชอบเรื่องร้องทุกข์",
    route: "LawLeaderDept",
    icon: "FileTextIcon",
    menu: "LawLeaderDept",
  },
  {
    title: "เจ้าหน้าที่",
    route: "LawOfficer",
    icon: "FileTextIcon",
    menu: "LawOfficer",
  },
  {
    title: 'รายการรับ - ส่งเรื่องร้องทุกข์',
    icon: 'CircleIcon',  
    menu: "LawComplaintSummary",  
    children: [
      {
        title: 'รายการส่งเรื่องร้องทุกข์',
        route: 'ComplaintSendSummary',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการรับเรื่องร้องทุกข์',
        route: 'ComplaintReceivedSummary',
        icon: 'CircleIcon',
      },
      {
        title: 'รายการรับ-ส่งเรื่องร้องทุกข์รายบุคคล',
        route: 'ComplaintPersonalSummary',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: "ดำเนินการเรื่องร้องทุกข์แบบกลุ่ม",
    route: null,
    icon: "CircleIcon",
    menu: "LawComplaintGroup",
  },
  {
    title: "ปรึกษากฏหมาย",
    route: 'LawConsult',
    icon: "CircleIcon",
    menu: "LawConsult",
  },
];
